import Measurements from './Measurements';

export default Measurements;
